import { mobileItemDetailActions } from '../../services';

export const mobileItemDetailReducer = ( state = [], action ) =>{
    switch(action.type){
        case mobileItemDetailActions.ADD:
            return [...state, action.data]
        default:
            return state;
    }
  }